import classNames from 'classnames';
import React, { ButtonHTMLAttributes, FC } from 'react';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  rightIcon?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Button: FC<IProps> = ({
  label,
  rightIcon,
  className,
  style,
  ...rest
}) => {
  return (
    <button
      className={classNames(
        'h-12 px-4 flex items-center gap-4 justify-center text-white bg-l-primary rounded-md font-semibold',
        className
      )}
      {...rest}
      style={style}
    >
      <span className='text-inherit'>{label}</span>
      {rightIcon && <img src={rightIcon} alt='' />}
    </button>
  );
};

export default Button;
